import { render, staticRenderFns } from "./DynamicGroupOperators.vue?vue&type=template&id=965b8f74&scoped=true&"
import script from "./DynamicGroupOperators.vue?vue&type=script&lang=ts&"
export * from "./DynamicGroupOperators.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicGroupOperators.vue?vue&type=style&index=0&id=965b8f74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965b8f74",
  null
  
)

export default component.exports